// GTM + Meta Pixel tracking helpers.
// Scripts are injected once at first call when IDs are present; subsequent
// calls are idempotent. Events are safe to call regardless of script load.

let gtmInjected = false;
let pixelInjected = false;

export function ensureGtm(containerId) {
  if (!containerId || gtmInjected) return;
  gtmInjected = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`;
  document.head.appendChild(s);
  // noscript fallback right after <body>
  const ns = document.createElement("noscript");
  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(containerId)}`;
  iframe.height = "0"; iframe.width = "0";
  iframe.style.cssText = "display:none;visibility:hidden";
  ns.appendChild(iframe);
  if (document.body.firstChild) {
    document.body.insertBefore(ns, document.body.firstChild);
  } else {
    document.body.appendChild(ns);
  }
}

export function ensureMetaPixel(pixelId) {
  if (!pixelId || pixelInjected) return;
  pixelInjected = true;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
}

export function trackLeadStarted(leadType) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "lead_started", lead_type: leadType });
  } catch {}
}

export function trackLeadSubmitted(leadType, product) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "lead_submitted",
      lead_type: leadType,
      product: product || "",
    });
  } catch {}
  try {
    if (typeof window.fbq === "function") {
      window.fbq("track", "Lead", {
        content_name: product || "",
        content_category: leadType,
      });
    }
  } catch {}
}
